<template>
	<b-modal
		no-close-on-backdrop
		no-close-on-esc
		:visible="value"
		size="xl"
		:hide-footer="hideFooter"
		scrollable
		no-fade
		id="modal-reservations"
		ok-only
		ok-title="Guardar"
		body-class="position-static"
		@close="$emit('close')"
		@ok="$emit('ok', $event)"
	>

		<slot />
		<template v-slot:modal-title>
			<slot name="modal-title" />
		</template>
	</b-modal>
</template>

<script>

export default {
	props: {
		value: Boolean,
		hideFooter: Boolean
	}
};
</script>

<style>
	#modal-reservations .modal-dialog{
		width: 96% !important;
		max-width: inherit;
	}
	@media (min-width: 1200px){
		#modal-reservations .modal-dialog{
			max-width: 1300px;
		}
		.table{
			font-size: .85rem;
		}
	}
</style>
